import React from 'react';

interface 모바일레이아웃속성 {
  children: React.ReactNode;
}

/**
 * 모바일 환경에 최적화된 레이아웃 컴포넌트
 * 안드로이드 크롬에서 스크롤 문제를 해결합니다
 */
export function MobileLayout({ children }: 모바일레이아웃속성): JSX.Element {
  return (
    <div className="mobile-layout-container">
      {children}
    </div>
  );
}
